import { motion } from "framer-motion";
import { C, mono, serif, sans, EASE, scrollTo } from "@/lib/theme";
import { useT, useLang } from "@/lib/i18n";

// Reusable "limited-time offer" CTA card (used in the hero and before the contact form).
const OfferBanner = ({ style }) => {
  const t = useT();
  const { lang } = useLang();
  return (
  <motion.div
    data-testid="offer-banner"
    initial={{ opacity: 0, y: 20 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.4 }}
    transition={{ duration: 0.9, ease: EASE }}
    style={{
      display: "flex",
      flexWrap: "wrap",
      alignItems: "center",
      justifyContent: "space-between",
      gap: "clamp(16px, 3vw, 40px)",
      padding: "clamp(18px, 2.4vw, 26px) clamp(20px, 2.6vw, 30px)",
      borderRadius: 4,
      border: "1px solid oklch(0.6 0.165 42 / 0.4)",
      background: "rgb(241, 233, 223)",
      borderLeft: `4px solid ${C.accent}`,
      ...style,
    }}
  >
    <div style={{ display: "flex", flexDirection: "column", gap: 8, maxWidth: "58ch" }}>
      <span style={{ display: "inline-flex", alignItems: "center", gap: 9, fontFamily: mono, fontSize: 10.5, letterSpacing: "0.2em", textTransform: "uppercase", color: C.accent }}>
        <span className="aw-avail-dot" style={{ width: 7, height: 7, borderRadius: 999, background: C.accent, display: "inline-block" }} />
        {t("Limited-time offer")}
      </span>
      <p style={{ margin: 0, fontFamily: serif, fontWeight: 400, fontSize: "clamp(21px, 2.3vw, 30px)", lineHeight: 1.15, letterSpacing: "-0.01em", color: C.ink }}>
        {lang === "fr" ? (
          <>Nouveaux projets : <span style={{ color: C.accent }}>-10%</span> — clients fidèles : <span style={{ color: C.accent }}>-15%</span>.</>
        ) : (
          <>New projects get <span style={{ color: C.accent }}>10% off</span> — returning clients save <span style={{ color: C.accent }}>15%</span>.</>
        )}
      </p>
      <p style={{ margin: 0, fontFamily: sans, fontSize: "clamp(13px, 1.1vw, 15px)", lineHeight: 1.55, color: C.text48 }}>
        {t("Booking a limited number of projects for the coming months — lock in your rate now.")}
      </p>
    </div>
    <a
      href="#contact"
      data-testid="offer-banner-cta"
      onClick={(e) => { e.preventDefault(); scrollTo("#contact"); }}
      className="aw-cta"
      style={{ flexShrink: 0, fontFamily: mono, fontSize: 11, letterSpacing: "0.14em", textTransform: "uppercase", padding: "16px 28px", borderRadius: 2, background: C.accent, color: "oklch(0.98 0.006 85)", whiteSpace: "nowrap" }}
    >
      {t("Claim your reduction →")}
    </a>
  </motion.div>
  );
};

export default OfferBanner;
